import { coreLegacyTimelineDetailsGetAsyncSlice } from './get';

export const { requestGetCoreLegacyTimelineDetails, resetGetCoreLegacyTimelineDetails } =
	coreLegacyTimelineDetailsGetAsyncSlice.asyncActionCreators;
